import {
  APP_INITIALIZER,
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  ErrorHandler,
  LOCALE_ID,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getRemoteConfig, provideRemoteConfig } from '@angular/fire/remote-config';
import { environment } from '@environments/environment';
import { OrquideaConfig } from '@nequi/design-system-lib/themes';
import { KeycloakAngularModule } from 'keycloak-angular';
import { DynamicScriptLoaderService } from '@shared/services/dynatrace/dynamic-script-loader.service';
import { scriptLoaderFactory } from '@shared/services/dynatrace/load-factory';
import { GlobalErrorHandler } from '@core/global-handler/global-error-handler';
import { DialogService } from 'primeng/dynamicdialog';
import { APP_ROUTES } from './app.routes';
import { serviceProvider } from '@core/service-providers/service-provider';
import { KeycloakInitService } from '@shared/utils/keycloak/keycloak-init.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(APP_ROUTES),
    provideAnimations(),
    providePrimeNG(OrquideaConfig),
    provideHttpClient(),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideRemoteConfig(() => getRemoteConfig()),
    importProvidersFrom(KeycloakAngularModule),
    DialogService,
    ...serviceProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: (service: KeycloakInitService) => () => service.initialize(),
      deps: [KeycloakInitService],
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: '$' },
    { provide: 'CLEVERTAP_KEY', useValue: environment.clevertapKey },
    {
      provide: APP_INITIALIZER,
      useFactory: scriptLoaderFactory,
      deps: [DynamicScriptLoaderService],
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
